import React, {useContext, useState} from 'react';
import { GlobalContext } from '../GlobalState';
import { Box, Chip } from '@mui/material';
import ActiveIcon from '@mui/icons-material/Person';
import InactiveIcon from '@mui/icons-material/PersonOff';

export const ChipUnitCodes = ({channel, onHeader}) => {
  const { globalState } = useContext(GlobalContext);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleIsExpanded = () => setIsExpanded(prev => !prev);
  const searchUnitOnTab = (unit) => window.open(`${globalState.app_config.backEnv}/vehicles?searchUnit=${encodeURIComponent(unit)}&openVehicleStatus=false`, '_blank', 'noopener,noreferrer');
  const parsedUnitCodes = (typeof channel.data.unitCode === 'string' && channel.data.unitCode !== '') ? channel.data.unitCode.split(' ').sort((a, b) => {
    if (a.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === true && b.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === false) return -1;
    else if (a.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === false && b.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === true) return 1;
    else return 0;
  }) : [];
  const parsedUnitCodes_chipLabel = parsedUnitCodes.length > 1 ? `${parsedUnitCodes[0]} +${parsedUnitCodes.length-1}`: `${parsedUnitCodes[0]}`;
  const parsedPrimaryCodes = (channel.data.unitsWithPrimaryContact) ? channel.data.unitsWithPrimaryContact : [];
  if (parsedUnitCodes.length === 0) return null;
  if (onHeader === true && isExpanded === true) return (
    <Box sx={{ display: 'inherit' }}>
      <Chip
      size='small'
      color='primary'  
      icon={channel.data.isDriverActive === true ? <ActiveIcon fontSize='small' color='primary'/> : <InactiveIcon fontSize='small' color='primary'/>}
      label={channel.data.isDriverActive === true ? 'Active' : 'Inactive'}
      onClick={toggleIsExpanded}
      />
      { parsedUnitCodes.map((unit, index) => <Chip
        key={channel.cid+unit+index} label={unit} size='small' color='primary' sx={{ml: 0.4}}
        variant={parsedPrimaryCodes.includes(unit) === true ? 'filled' : 'outlined'}
        onClick={() => searchUnitOnTab(unit)}
        />) }
    </Box>
  );
  if (onHeader === true && isExpanded === false) return (
    <Box>
      <Chip
        size='small'
        color='primary'  
        icon={channel.data.isDriverActive === true ? <ActiveIcon fontSize='small' color='primary'/> : <InactiveIcon fontSize='small' color='primary'/>}
        label={parsedUnitCodes_chipLabel}
        onClick={toggleIsExpanded}
        variant={parsedPrimaryCodes.includes(parsedUnitCodes[0]) === true ? 'filled' : 'outlined'}
        />
    </Box>
  );
  return (
    <Box>
      <Chip
        size='small'
        color='primary'  
        icon={channel.data.isDriverActive === true ? <ActiveIcon fontSize='small' color='primary'/> : <InactiveIcon fontSize='small' color='primary'/>}
        label={parsedUnitCodes_chipLabel}
        variant={parsedPrimaryCodes.includes(parsedUnitCodes[0]) === true ? 'filled' : 'outlined'}
        />
    </Box>
  );
};